import React from 'react';
import Checkbox from '../../ui/checkbox/checkbox';
import ExternalLink from '../../ui/externalLink/externalLink';
import './checkboxCard.css';


export default function CheckboxCard({title, description, required = true, links = null, onChange = () => {}}) {

    return (
        <div className='neo-checkboxCard-container'>
            <div className='neo-checkboxCard-checkbox'>
                <Checkbox onChange={onChange}/>
            </div>
            <div className='neo-checkboxCard-content'>
                <h6 className='neo-checkboxCard-title'>
                    {title}{required && <span className='neo-cgv-required'>*</span>}
                </h6>
                <p className='neo-checkboxCard-description'>{description}</p>
                {links && <nav className='neo-checkboxCard-links'>
                    {links.map(({key, url, label}) => <ExternalLink key={key} href={url} text={label}/>)}
                </nav>}
            </div>
        </div>
    )
}
